import { normalizeCityCode } from './cityCode';

/**
 * Normalize stored region (cityCode, slug, or legacy label) to canonical locations.code.
 * @param {string | null | undefined} region
 * @returns {string}
 */
export function normalizeBusinessCityCode(region) {
  return normalizeCityCode(region);
}

/**
 * @param {{ region?: string }} biz
 * @param {string | null | undefined} userCityCode
 */
export function businessInUserCityCode(biz, userCityCode) {
  const userCode = normalizeCityCode(userCityCode);
  if (!userCode) return true;

  const bizCode = normalizeBusinessCityCode(biz?.region);
  if (!bizCode) return false;
  return bizCode === userCode;
}

/**
 * @param {{ region?: string }} biz
 * @param {string[]} userCityCodes cityCode values (e.g. ['danang'])
 */
export function businessInUserRegions(biz, userCityCodes) {
  if (!userCityCodes?.length) return true;
  return userCityCodes.some((code) => businessInUserCityCode(biz, code));
}
